import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { FinancialEcomsyncItemSyncingQueueContainerModel} from '../../../../../../models/aggregates/erp/financial';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class FinancialEcomsyncItemSyncingQueueService extends BaseApiTemplateService<FinancialEcomsyncItemSyncingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'item-syncing-queue';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'item-syncing-queue';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'item-syncing-queue';
    this.httpClient = http;
  }

}
